module.exports = __webpack_public_path__ + "static/img/supply_active.1d202f9e.svg";